import request from '@/utils/request'

// 删除购物车
export function deleteGoods(data) {
    return request({
        url: '/cart/delete',
        method: 'post',
        data: data
    })
}

// 刷新cart
export function cart(data) {
    return request({
        url: '/cart/cart',
        method: 'post',
        data: data
    })
}

// 采购计划列表
export function findCrePlan(data) {
    return request({
        url: '/plan/findCrePlan',
        method: 'post',
        data: data
    })
}
//头部导航栏商品搜索带建议搜索
export function getRecommendedWords(params){
    return request({
        url:'/search/interface/getRecommendedWords?query='+encodeURIComponent(params.query),
        method:'get'
    })
}
//头部导航栏商品热门搜索
export function getHotSearch(){
    return request({
        url:'/search/interface/getHotSearch',
        method:'get'
    })
}

// export function findCrePlan(params) {
//     return request({
//         url: '/plan/findCrePlan',
//         method: 'get',
//         params: params
//     })
// }


// WEBPACK FOOTER //
// ./src/api/searchbox.js